import React from "react";
import {Tabs} from "@amzn/awsui-components-react-v3";
import {AggregateCablingManifestBySite} from "../plannedDeliveries/interface/AggregateCablingManifestBySite";
import CablingManifestSummaryTable from "./CablingManifestSummaryTable";
import {CABLING_MANIFEST_TABLE_CONSTANT} from "../LmdpConstants";
import {CablingStatusWiseItemsCount} from "./interface/CablingStatusWiseItemsCount";

interface Props {
    items: AggregateCablingManifestBySite[];
    isLoading: boolean;
}

export default function CablingStatusTab(props: Props) {

    const [notCabledCount,setNotCabledCount] = React.useState<number>(0);
    const [cablingInProgressCount, setCablingInProgressCount] = React.useState<number>(0);
    const [cablingCompletedCount,setCablingCompletedCount] = React.useState<number>(0);

    function setCount(statusCount: CablingStatusWiseItemsCount) {
        setNotCabledCount(statusCount.notCabledCount);
        setCablingCompletedCount(statusCount.cablingCompletedCount);
        setCablingInProgressCount(statusCount.cablingInProgressCount);
    }

    return (
        <div>
            <Tabs
                variant="container"
                tabs={[
                    {
                        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.NOT_CABLED + (props.isLoading ? "" : "(" + notCabledCount + ")"),
                        id: "first",
                        content: (<CablingManifestSummaryTable
                            items={props.items}
                            cablingStatus={CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.NOT_CABLED}
                            isLoading={props.isLoading}
                            statusCount={setCount}
                        />),
                    },
                    {
                        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_IN_PROGRESS + (props.isLoading ? "" :  "(" + cablingInProgressCount + ")"),
                        id: "second",
                        content: (<CablingManifestSummaryTable
                            items={props.items}
                            cablingStatus={CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_IN_PROGRESS}
                            isLoading={props.isLoading}
                            statusCount={setCount}
                        />),
                    },
                    {
                        label: CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_COMPLETED + (props.isLoading ? "" : "(" + cablingCompletedCount + ")"),
                        id: "third",
                        content: (<CablingManifestSummaryTable
                            items={props.items}
                            cablingStatus={CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_COMPLETED}
                            isLoading={props.isLoading}
                            statusCount={setCount}
                        />),
                    }
                ]}
            />
        </div>
    );
}